/**
 * The legal pages (Terms, Privacy, Cookies) as data. Each document renders
 * through the legal shell (app/components/site/legal): the hero and switcher
 * come from `slug`, `title` and `meta`, the table of contents from
 * `sections`, and the prose from `intro` plus each section's `html`.
 *
 * Section bodies are our own static HTML (h3s, lists, the `tt-legal-caps`
 * disclaimer block, `tt-legal-note` / `tt-legal-callout` boxes, the
 * `tt-legal-addr` contact card), rendered with dangerouslySetInnerHTML. Text
 * that is already entity-encoded stays encoded.
 */
export type LegalSlug = 'terms' | 'privacy' | 'cookies'

export interface LegalSection {
	/** The h2's id and the anchor the table of contents links to. */
	id: string
	/** The short label shown in the table of contents. */
	tocLabel: string
	/** The full h2 text. */
	heading: string
	/** Everything between this h2 and the next one. */
	html: string
}

export interface LegalDocument {
	slug: LegalSlug
	/** The hero title as set, for example "Terms Of Service." */
	title: string
	/** Lines under the switcher such as "Effective Date: June 24, 2026". */
	meta: readonly string[]
	/** The paragraphs before the first section. The first one is the lead. */
	intro: string
	sections: readonly LegalSection[]
}

/**
 * The contact card that ends the Terms, at support@ per the client's TT-157
 * QA note of 2026-10-01. Privacy and Cookies carry their own Privacy Officer
 * cards (reference of 2026-10-02).
 */
export const LEGAL_CONTACT_CARD =
	'<p class="tt-legal-addr">TrueTenant Inc.<br>713 Indian Road<br>Mississauga, Ontario L5H 1R3, Canada<br>Email: <a href="mailto:support@truetenant.ai">support@truetenant.ai</a><br>Online: <a href="https://truetenant.ai">truetenant.ai</a></p>'
